module.exports = __webpack_public_path__ + "static/media/tsb4ru.1cdd092b.pdf";